import { IPluginMetadataSucceededResult } from 'app/apis/plugin-metadata-api.service';
import { IStringMap } from 'app/interfaces/IStringMap';
import { IIconMetadata } from 'app/extensibility/metadatas/icon-metadata';

export interface IIconRegistery {
    icon: IIconMetadata;
}

export const dynamicConnectorIconRegistery: IStringMap<IIconRegistery> = {
    OData: {
        icon: {
            className: 'svg-i-100x100-OData'
        }
    },
    LinkedService: {
        icon: {
            className: 'svg-i-20x20-linkedservice'
        }
    },
    Dataset: {
        icon: {
            className: 'svg-i-100x100-PlaceHolderDatabase'
        }
    }
};

export const allExistingDynamicConnectorConfiguration: IPluginMetadataSucceededResult[] = [
    {
        connectorName: 'Microsoft.ComplexFileSample',
        dataType: 'Binary',
        SupportEncryption: true,
        connectionSettings: [
            {
                name: 'connectionString',
                type: 'String',
                required: true,
                sensitive: true
            },
            {
                name: 'copyBehavior',
                type: 'String',
                required: true,
                defaultValue: 'merge'
            },
            {
                name: 'copyBehaviorRadio',
                type: 'string',
                required: true,
                defaultValue: 'test'
            },
            {
                name: 'compression',
                type: 'object',
                defaultValue: 'TEST'
            },
            {
                name: 'copyCommand',
                type: 'array'
            }
        ],
        readSettings: [
            {
                name: 'myContainer',
                type: 'String',
                required: true
            },
            {
                name: 'myFolderPath',
                type: 'String',
                required: true
            },
            {
                name: 'myFileName',
                type: 'String',
                required: true
            },
            {
                name: 'myMaxConcurrentConnection',
                type: 'Double',
                required: true
            },
            {
                name: 'myObjectTest',
                type: 'object',
                required: true
            }
        ],
        writeSettings: [
            {
                name: 'myContainer',
                type: 'String',
                required: true,
                defaultValue: 'https://xxx'
            },
            {
                name: 'myFolderPath',
                type: 'String',
                required: true
            },
            {
                name: 'myFileName',
                type: 'String',
                required: true
            },
            {
                name: 'myMaxConcurrentConnection',
                type: 'Double',
                required: true,
                defaultValue: 123
            },
            {
                name: 'myObjectTest',
                type: 'object',
                required: true
            }
        ],
        adfAppModelConfiguration: {
            displayName: 'Complex File Sample (filepath-based, conenction String, azure resource)',
            linkedService: {
                uiControls: [
                    {
                        bind: 'connectionString',
                        controlType: 'ConnectionStringContainer',
                        controlSettings: {
                            properties: [
                                {
                                    bind: {
                                        resourceName: 'AccountName',
                                        resourceKey: 'AccountKey'
                                    },
                                    controlType: 'AzureResourceSelection',
                                    controlSettings: {
                                        resourceTypes: ['Microsoft.Search/searchServices'],
                                        resourceDisplayName: 'Service name',
                                        resourceConvertTemplate: 'https://<resourceName>.search.windows.net',
                                        supportListKey: true,
                                        listKeyAction: 'listAdminKeys',
                                        listKeyApiVersion: '2015-08-19',
                                        keyResponseKeywords: ['primaryKey', 'secondaryKey']
                                    }
                                },
                                {
                                    bind: 'DefaultEndpointsProtocol',
                                    placeholder: 'abcd'
                                },
                                {
                                    bind: 'EndpointSuffix',
                                    placeholder: 'abcd'
                                }
                            ],
                            sensitiveProperties: ['AccountKey']
                        }
                    },
                    {
                        bind: 'copyBehavior',
                        controlType: 'DropDown',
                        controlSettings: {
                            options: [{
                                value: 'merge',
                                label: 'Merge'
                            },
                            {
                                value: 'flattern',
                                label: 'Flattern'
                            }]
                        },
                        displayName: 'Copy behavior',
                        description: 'The copy behavior when writing data into data store'
                    },
                    {
                        bind: 'copyBehaviorRadio',
                        controlType: 'RadioButton',
                        controlSettings: {
                            options: [{
                                value: 'merge',
                                label: 'Merge'
                            },
                            {
                                value: 'flattern',
                                label: 'Label'
                            }]
                        },
                        displayName: 'Copy behavior Radio',
                        description: 'The copy behavior when writing data into data store'
                    },
                    {
                        bind: 'copyCommand',
                        controlType: 'ArrayContainer',
                        controlSettings: {
                            itemUiControl: {
                                bind: '',
                                controlType: 'ArrayContainer',
                                displayName: 'Inner array',
                                description: 'Inner array'
                            }
                        },
                        displayName: 'Copy command'
                    },
                    {
                        bind: '_managementIdentityInfo',
                        controlType: 'ManagementIdentityInfo',
                        controlSettings: {
                            docLink: 'https://docs.microsoft.com/azure/data-factory/connector-azure-blob-storage#managed-identity',
                            linkDisplayName: 'Azure Blob dynamic version'
                        }
                    }
                ]
            },
            location: {
                properties: ['myContainer', 'myFolderPath', 'myFileName'],
                uiControls: [
                    {
                        bind: 'myContainer',
                        controlType: 'TextBox',
                        displayName: 'Path',
                        description: 'The description of the URL',
                        placeholder: 'abcd'
                    },
                    {
                        controlType: 'FileLocation',
                        displayName: 'My sample file path',
                        controlSettings: {
                            properties: [{
                                controlType: 'TextBox',
                                bind: 'myFolderPath',
                                placeholder: 'abcd'
                            },
                            {
                                controlType: 'TextBox',
                                bind: 'myFileName',
                                placeholder: 'abcd'
                            }],
                            fileNameProperty: 'myFileName'
                        }
                    }
                ]
            },
            storeReadSettings: {
                properties: ['myMaxConcurrentConnection', 'myObjectTest'],
                uiControls: [
                    {
                        bind: 'myObjectTest',
                        controlType: 'ArrayContainer',
                        controlSettings: {
                            itemUiControl: {
                                bind: '',
                                controlType: 'ArrayContainer',
                                displayName: 'Inner array',
                                description: 'Inner array'
                            }
                        },
                        displayName: 'My Object Test Array'
                    }
                ]
            },
            storeWriteSettings: {
                properties: ['myMaxConcurrentConnection', 'myObjectTest'],
                uiControls: [
                    {
                        bind: 'myObjectTest',
                        controlType: 'ArrayContainer',
                        controlSettings: {
                            itemUiControl: {
                                dataType: 'Double'
                            }
                        }
                    }
                ]
            }
        }
    },
    {
        connectorName: 'Microsoft.FileSamplePathBased',
        dataType: 'Binary',
        SupportEncryption: false,
        connectionSettings: [
            {
                name: 'connectionStringa',
                type: 'String',
                required: true
            }
        ],
        readSettings: [
            {
                name: 'myContainer',
                type: 'String',
                required: true
            },
            {
                name: 'myFolderPath',
                type: 'String',
                required: true
            },
            {
                name: 'myFileName',
                type: 'String',
                required: true
            },
            {
                name: 'myObjectTest',
                type: 'object',
                required: true
            }
        ],
        writeSettings: [
            {
                name: 'myContainer',
                type: 'String',
                required: true
            },
            {
                name: 'myFolderPath',
                type: 'String',
                required: true
            },
            {
                name: 'myFileName',
                type: 'String',
                required: true
            },
            {
                name: 'myObjectTest',
                type: 'object',
                required: true
            },
            {
                name: 'myDateTimeTest',
                type: 'DateTime',
                required: true
            },
            {
                name: 'myDateTimeOffsetTest',
                type: 'DateTimeOffset',
                required: true
            }
        ],
        adfAppModelConfiguration: {
            category: ['ThirdParty', 'File'],
            linkedService: {
                uiControls: [
                    {
                        bind: 'connectionStringa',
                        controlType: 'ConnectionStringContainer',
                        controlSettings: {
                            properties: [
                                {

                                    bind: 'accountKey',
                                    placeholder: 'abcd',
                                    displayName: 'Account Key'
                                },
                                {
                                    bind: 'DefaultEndpointsProtocol',
                                    placeholder: 'abcd',
                                    displayName: 'Default Endpoints Protocol'
                                },
                                {
                                    bind: 'EndpointSuffix',
                                    placeholder: 'abcd',
                                    displayName: 'Endpoint Suffix'
                                }
                            ],
                            sensitiveProperties: ['accountKey']
                        }
                    }
                ]
            },
            location: {
                properties: ['myContainer', 'myFolderPath', 'myFileName'],
                uiControls: [
                    {
                        bind: 'myContainer',
                        controlType: 'TextBox',
                        displayName: 'Path',
                        description: 'The description of the URL',
                        placeholder: 'abcd'
                    },
                    {
                        controlType: 'FileLocation',
                        displayName: 'My simple sample file path',
                        controlSettings: {
                            properties: [{
                                controlType: 'TextBox',
                                bind: 'myFolderPath',
                                placeholder: 'abcd'
                            },
                            {
                                controlType: 'TextBox',
                                bind: 'myFileName',
                                placeholder: 'abcd'
                            }],
                            fileNameProperty: 'myFileName'
                        }
                    }
                ]
            },
            storeReadSettings: {
                properties: ['myObjectTest']
            },
            storeWriteSettings: {
                properties: ['myObjectTest', 'myDateTimeTest', 'myDateTimeOffsetTest']
            }
        }
    },
    {
        connectorName: 'FileSampleFreePath',
        dataType: 'Binary',
        SupportEncryption: true,
        connectionSettings: [
            {
                name: 'connectionString',
                type: 'String',
                required: true,
                sensitive: true
            }
        ],
        readSettings: [
            {
                name: 'myContainer',
                type: 'String',
                required: true
            },
            {
                name: 'myFolderPath',
                type: 'String',
                required: true
            },
            {
                name: 'myFileName',
                type: 'String',
                required: true
            },
            {
                name: 'store1',
                type: 'String',
                required: true
            }
        ],
        writeSettings: [
            {
                name: 'myContainer',
                type: 'String',
                required: true
            },
            {
                name: 'myFolderPath',
                type: 'String',
                required: true
            },
            {
                name: 'myFileName',
                type: 'String',
                required: true
            },
            {
                name: 'store1',
                type: 'String',
                required: true
            }
        ],
        adfAppModelConfiguration: {
            category: ['File', 'ThirdParty'],
            location: {
                properties: ['myContainer', 'myFolderPath', 'myFileName']
            },
            storeReadSettings: {
                properties: ['store1']
            },
            storeWriteSettings: {
                properties: ['store1']
            }
        }
    },
    {
        connectorName: 'FileSampleSourceOnly',
        dataType: 'Binary',
        SupportEncryption: true,
        connectionSettings: [
            {
                name: 'connectionString',
                type: 'String',
                required: true,
                sensitive: true
            }
        ],
        readSettings: [
            {
                name: 'myContainer',
                type: 'String',
                required: true
            },
            {
                name: 'myFolderPath',
                type: 'String',
                required: true
            },
            {
                name: 'myFileName',
                type: 'String',
                required: true
            },
            {
                name: 'store1',
                type: 'String',
                required: true
            }
        ],
        adfAppModelConfiguration: {
            category: ['File', 'ThirdParty'],
            location: {
                properties: ['myContainer', 'myFolderPath', 'myFileName']
            },
            storeReadSettings: {}
        }
    },
    {
        connectorName: 'FileSampleSinkOnly',
        dataType: 'Binary',
        SupportEncryption: true,
        connectionSettings: [
            {
                name: 'connectionString',
                type: 'String',
                required: true
            },
            {
                name: 'testSensitive',
                type: 'String',
                required: true,
                sensitive: true
            }
        ],
        writeSettings: [
            {
                name: 'myContainer',
                type: 'String',
                required: true
            },
            {
                name: 'myFolderPath',
                type: 'String',
                required: true
            },
            {
                name: 'myFileName',
                type: 'String',
                required: true
            },
            {
                name: 'store1',
                type: 'String',
                required: true
            }
        ],
        sensitiveFields: ['connectionString'],
        adfAppModelConfiguration: {
            category: ['File', 'ThirdParty'],
            location: {
                properties: ['myContainer', 'myFolderPath', 'myFileName']
            },
            storeWriteSettings: {
                properties: ['store1']
            }
        }
    },
    {
        connectorName: 'TabularSample',
        dataType: 'Tabular',
        SupportEncryption: true,
        connectionSettings: [
            {
                name: 'username',
                type: 'String',
                signature: true,
                required: true
            },
            {
                name: 'password',
                type: 'String',
                sensitive: true,
                required: true
            },
            {
                name: 'server',
                type: 'String',
                signature: true,
                required: true
            },
            {
                name: 'database',
                type: 'String',
                signature: true,
                required: true
            }

        ],
        sensitiveFields: ['password'],
        signatureFields: [],
        readSettings: [
            {
                name: 'table',
                type: 'String'
            },
            {
                name: 'schema',
                type: 'String'
            },
            {
                name: 'myQuery',
                type: 'String'
            },
            {
                name: 'myQueryTimeOut',
                type: 'String'
            }
        ],
        writeSettings: [
            {
                name: 'table',
                type: 'String'
            },
            {
                name: 'schema',
                type: 'String'
            },
            {
                name: 'writeBatchSize',
                type: 'String'
            }
        ],
        adfAppModelConfiguration: {
            category: ['Database', 'ThirdParty'],
            displayName: 'Sample Tabular Database',
            dataset: {
                properties: [
                    'schema',
                    'table'
                ],
                uiControls: [
                    {
                        bind: 'schema',
                        controlType: 'TableSelection',
                        displayName: 'My test table'
                    }
                ]
            },
            copySource: {
                properties: ['myQuery', 'myQueryTimeOut'],
                uiControls: [
                    {
                        bind: 'myQuery',
                        controlType: 'QueryTextArea',
                        displayName: 'My Test Query'
                    },
                    {
                        bind: 'myQueryTimeOut',
                        controlType: 'TextBox',
                        displayName: 'My Test Query Timeout'
                    }
                ]
            },
            copySink: {
                properties: ['writeBatchSize'],
                uiControls: [
                    {
                        bind: 'writeBatchSize',
                        controlType: 'TextBox'
                    }
                ]
            }
        }
    },
    {
        connectorName: 'FileSampleEmptyV2Settings',
        dataType: 'Binary',
        SupportEncryption: false,
        connectionSettings: [
            {
                name: 'connectionString',
                type: 'String',
                required: true
            }
        ],
        readSettings: [
            {
                name: 'myContainer',
                type: 'String',
                required: true
            }
        ],
        writeSettings: [
            {
                name: 'myContainer',
                type: 'String',
                required: true
            }
        ],
        sensitiveFields: ['connectionString'],
        adfAppModelConfiguration: {
            category: ['File', 'ThirdParty']
        }
    },
    {
        connectorName: 'SqlSampleEmptyV2Settings',
        dataType: 'Tabular',
        SupportEncryption: true,
        connectionSettings: [
            {
                name: 'username',
                type: 'String',
                signature: true,
                required: true
            }
        ],
        signatureFields: [],
        readSettings: [
            {
                name: 'table',
                type: 'String'
            }
        ],
        adfAppModelConfiguration: {
            category: ['Database', 'ThirdParty']
        }
    }
];
